/* src/app/shared/components/menu/menu-vertical.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.menu.vertical > .menu-content-wrapper > .menu-content > .menu-items > .menu-item > .mat-mdc-button {
  padding-left: 1em;
}
.menu.vertical .menu-items,
.menu.vertical .sub-menu-items {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.menu.vertical .menu-items > .menu-item > .mat-mdc-button,
.menu.vertical .sub-menu-items > .menu-item > .mat-mdc-button {
  padding-left: 1.925em;
}
.menu.vertical .menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button,
.menu.vertical .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button {
  padding-left: 3.85em;
}
.menu.vertical .menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button,
.menu.vertical .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button {
  padding-left: 5.775em;
}
.menu.vertical .menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button,
.menu.vertical .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button {
  padding-left: 7.7em;
}
.menu.vertical .menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button,
.menu.vertical .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button {
  padding-left: 9.625em;
}
.menu.vertical .menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button,
.menu.vertical .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button {
  padding-left: 11.55em;
}
.menu.vertical .menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button,
.menu.vertical .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button {
  padding-left: 13.475em;
}
.menu.vertical .menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button,
.menu.vertical .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button {
  padding-left: 15.4em;
}
.menu.vertical .menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button,
.menu.vertical .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button {
  padding-left: 17.325em;
}
.menu.vertical .menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button,
.menu.vertical .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button {
  padding-left: 19.25em;
}
.menu.vertical .menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button,
.menu.vertical .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .sub-menu-items > .menu-item > .mat-mdc-button {
  padding-left: 21.175em;
}
.menu.vertical .menu-items .menu-item.has-sub-menu,
.menu.vertical .sub-menu-items .menu-item.has-sub-menu {
  position: relative;
  overflow: hidden;
}
.menu.vertical .menu-items .menu-item.has-sub-menu > .mat-mdc-button::after,
.menu.vertical .sub-menu-items .menu-item.has-sub-menu > .mat-mdc-button::after {
  font-family: "Material Icons";
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0.5em;
  font-size: 1.25em;
  transform: translateZ(0);
  color: currentColor;
  opacity: 0.54;
  content: "\e313";
}
.menu.vertical .menu-items .menu-item.has-sub-menu > .mat-mdc-button:hover::after,
.menu.vertical .sub-menu-items .menu-item.has-sub-menu > .mat-mdc-button:hover::after {
  animation-duration: 0.3s, 1.5s;
  animation-delay: 0s, 0.3s;
  animation-timing-function: ease-out, ease-in-out;
  animation-iteration-count: 1, infinite;
  animation-fill-mode: forwards;
  animation-direction: normal, alternate;
  animation-name: hvr-icon-hang-sink, hvr-icon-hang;
}
.menu.vertical .menu-items .menu-item.has-sub-menu > .sub-menu-items,
.menu.vertical .sub-menu-items .menu-item.has-sub-menu > .sub-menu-items {
  height: 0;
  transform: scaleY(0);
  transform-origin: top;
  transition: transform 0.225s cubic-bezier(0.4, 0, 0.2, 1);
}
.menu.vertical .menu-items .menu-item.has-sub-menu.opened > .mat-mdc-button::after,
.menu.vertical .sub-menu-items .menu-item.has-sub-menu.opened > .mat-mdc-button::after {
  font-family: "Material Icons";
  display: inline-block;
  position: absolute;
  top: 0;
  right: 0.5em;
  font-size: 1.25em;
  transform: translateZ(0);
  color: currentColor;
  opacity: 0.54;
  content: "\e316";
}
.menu.vertical .menu-items .menu-item.has-sub-menu.opened > .mat-mdc-button:hover::after,
.menu.vertical .sub-menu-items .menu-item.has-sub-menu.opened > .mat-mdc-button:hover::after {
  animation-duration: 0.3s, 1.5s;
  animation-delay: 0s, 0.3s;
  animation-timing-function: ease-out, ease-in-out;
  animation-iteration-count: 1, infinite;
  animation-fill-mode: forwards;
  animation-direction: normal, alternate;
  animation-name: hvr-icon-bob-float, hvr-icon-bob;
}
.menu.vertical .menu-items .menu-item.has-sub-menu.opened > .sub-menu-items,
.menu.vertical .sub-menu-items .menu-item.has-sub-menu.opened > .sub-menu-items {
  height: auto;
  transform: scaleY(1);
}
.menu.vertical .menu-items .menu-item > .mat-mdc-button.active,
.menu.vertical .sub-menu-items .menu-item > .mat-mdc-button.active {
  background-color: #004791;
}
.menu.vertical .menu-items .mat-mdc-button,
.menu.vertical .sub-menu-items .mat-mdc-button {
  width: 100%;
  text-align: left;
  color: #404040;
  background-color: white;
  font-size: 1em;
  padding-top: 0.25em;
  padding-bottom: 0.25em;
}
.menu.vertical .menu-items .mat-mdc-button:hover,
.menu.vertical .menu-items .mat-mdc-button:focus,
.menu.vertical .sub-menu-items .mat-mdc-button:hover,
.menu.vertical .sub-menu-items .mat-mdc-button:focus {
  color: inherit;
  text-decoration: none;
}
.menu.vertical .menu-items .mat-mdc-button:focus,
.menu.vertical .sub-menu-items .mat-mdc-button:focus {
  outline: none;
}
.menu.vertical .menu-items .mat-mdc-button .mat-icon,
.menu.vertical .sub-menu-items .mat-mdc-button .mat-icon {
  margin-right: 0.25em;
}
/*# sourceMappingURL=menu-vertical.component.css.map */
